/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskSubmissionVersionDetailContentHash } from './taskSubmissionVersionDetailContentHash';

/**
 * Full version with content for preview/restore operations
 */
export interface TaskSubmissionVersionDetail {
  /** Monotonic sequence number for this version */
  versionSeq: number;
  /** When this version was created */
  createdAt: string;
  /** Character count of content */
  sizeChars: number;
  /** Whether this version is pinned to prevent pruning */
  pinned: boolean;
  /** SHA256 hash for deduplication checks */
  contentHash?: TaskSubmissionVersionDetailContentHash;
  /** Full HTML content snapshot for this checkpoint */
  content: string;
}
